import { render, staticRenderFns } from "./Donate.vue?vue&type=template&id=5fa9dead&scoped=true"
import script from "./Donate.vue?vue&type=script&lang=ts"
export * from "./Donate.vue?vue&type=script&lang=ts"
import style0 from "./Donate.vue?vue&type=style&index=0&id=5fa9dead&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9dead",
  null
  
)

export default component.exports